import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import { groupHomeActions } from 'srcReact/GroupHomePage'
import LightProfileModal from 'srcReact/components/common2/LightProfileModal'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'

const PendingMembers = ({ groupId, user, index, members }) => {
  const dispatch = useDispatch()

  const showUserModal = () => {
    const lp = new LightProfileProto()
    lp.userId = user.id
    lp.userIndex = index
    lp.users = members
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  return (
    <div className={styles.pendingMembersWrapper}>
      <div className={styles.user}>
        <img src={user.profile_picture} alt={user.lastname} className={styles.picture} onClick={showUserModal} />
        <div className={styles.info}>
          <div className={styles.name}>{user.firstname + ' ' + user.lastname}</div>
          <div className={styles.action}>
            <div
              className={styles.closeIcon}
              onClick={() => dispatch(groupHomeActions.memberPendingRejectGroup(groupId, user.id))}>
              <Icon name='close' size='x-small' />
            </div>
            <div
              className={styles.checkedIcon}
              onClick={() => dispatch(groupHomeActions.memberPendingApproveGroup(groupId, user.id))}>
              <Icon name='checked' size='medium' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PendingMembers
